export const locations = [
  { title: "Paris, Île-de-France, France", code: "par" },
  { title: "London, England, United Kingdom", code: "lon" },
  { title: "Berlin, Germany", code: "ber" },
  { title: "Madrid, Spain", code: "mad" },
  { title: "Rome, Lazio, Italy", code: "rom" },
  { title: "Amsterdam, North Holland, Netherlands", code: "ams" },
  { title: "Vienna, Austria", code: "vie" },
  { title: "Prague, Czech Republic", code: "prg" },
  { title: "Dublin, Ireland", code: "dub" },
  { title: "Copenhagen, Denmark", code: "cph" },
  { title: "Stockholm, Sweden", code: "sto" },
  { title: "Oslo, Norway", code: "osl" },
  { title: "Helsinki, Finland", code: "hel" },
  { title: "Brussels, Belgium", code: "bru" },
  { title: "Lisbon, Portugal", code: "lis" },
  { title: "Zurich, Switzerland", code: "zur" },
  { title: "Athens, Greece", code: "ath" },
  { title: "Warsaw, Poland", code: "waw" },
  { title: "Budapest, Hungary", code: "bud" },
  { title: "Reykjavik, Iceland", code: "rey" },
  { title: "Tallinn, Estonia", code: "tal" },
  { title: "Riga, Latvia", code: "rga" },
  { title: "Vilnius, Lithuania", code: "vil" },
  { title: "Sofia, Bulgaria", code: "sof" },
  { title: "Belgrade, Serbia", code: "beg" },
  { title: "Zagreb, Croatia", code: "zag" },
  { title: "Ljubljana, Slovenia", code: "lju" },
  { title: "Bratislava, Slovakia", code: "bts" },
  { title: "Sarajevo, Bosnia and Herzegovina", code: "sar" },
  { title: "Podgorica, Montenegro", code: "pod" },
  { title: "Skopje, North Macedonia", code: "skp" },
  { title: "Tirana, Albania", code: "tir" },
  { title: "Valletta, Malta", code: "val" },
  { title: "Luxembourg City, Luxembourg", code: "lux" },
  { title: "Monaco, Monaco", code: "mcn" },
  { title: "Andorra la Vella, Andorra", code: "and" },
  { title: "San Marino, San Marino", code: "smr" },
  { title: "Vaduz, Liechtenstein", code: "vad" },
  { title: "Hamburg, Germany", code: "ham" },
  { title: "Munich, Germany", code: "muc" },
  { title: "Barcelona, Spain", code: "bcn" },
  { title: "Seville, Spain", code: "svq" },
  { title: "Milan, Italy", code: "mil" },
  { title: "Naples, Italy", code: "nap" },
  { title: "Kraków, Poland", code: "krk" },
  { title: "Edinburgh, Scotland, United Kingdom", code: "edi" },
  { title: "Glasgow, Scotland, United Kingdom", code: "gla" },
  { title: "Lyon, Auvergne-Rhône-Alpes, France", code: "lyo" },
  { title: "Nice, Provence-Alpes-Côte d'Azur, France", code: "nic" },
];
